module.exports = __webpack_public_path__ + "img/project_11.79411906.png";